/**
 * Mobile navigation hamburger toggle button
 */

const hamburger = document.getElementById('hamburger');
const hamburgerInner = document.getElementById('hamburgerInner');
const menu = document.getElementById('slideMenu');
const body = document.querySelector('body');

hamburger.addEventListener('click', function() {
    hamburgerInner.classList.toggle('active');
    menu.classList.toggle('show');
    body.classList.toggle('no-scroll');
});

// console.log("Hamburger >>>>>>>>>>!");